export default __webpack_public_path__ + "static/assets/117680f5f35f92e789ca6750077aaa86.png";